export const LOCATION_STATE_OFFER = 'Offer';
export const LOCATION_STATE_HOTEL = 'Hotel';
export const BOOKINGID_STORAGE_KEY = 'BID';
export const SMALL_GROUP = 'isSmallGroup';
export const MINI_GROUP = 'isMiniGroup';
export const NORMAL_GROUP = 'isNormalGroup';
export const SMALL_GROUP_IMG = '/img/groupSize/Logo_kleingruppe.svg';
export const MINI_GROUP_IMG = '/img/groupSize/Logo_minigruppe.svg';
